import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Order, SelectedItem} from '../../../order/models/order';
import {Observable, Subscription} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {select, Store} from '@ngrx/store';
import * as fromOrders from '../../../order/reducers';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigOrderService} from '../../../order/services/get-config-order.service';
import {OrderClearAction} from '../../../order/actions/order-load';
import {ClearSelectItemAction} from '../../index';
import {skipWhile} from 'rxjs/operators';
import * as _ from 'lodash';
import {CloseOrdersAction} from '../../../order/actions/close-order';
import * as moment from 'moment';
import {BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import {Router} from '@angular/router';
import * as fromRoot from '../../reducers';
import {ClearOneItemSubListAction} from '../../actions/subscription-list';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-manually-close-order',
  templateUrl: './manually-close-order.component.html',
  styleUrls: ['./manually-close-order.component.scss']
})
export class ManuallyCloseOrderComponent  implements OnInit, OnDestroy {

  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  @Input() selectedItemUuid: string;
  @Input() selectedOrders: Order[];
  order$: Observable<Order>;
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  // tslint:disable-next-line:no-any
  form: FormGroup;
  formConfig: GroupConfig;
  selectedItemsUuid: string[];
  private sub$: Subscription;
  private subscriptions = [];


  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromOrders.AppState>,
              private getFormsService: GetFormsService,
              private router: Router,
              private bsModalRef: BsModalRef,
              private getConfigOrder: GetConfigOrderService) {
  }

  get isAnomalies(): boolean {
    if (this.router) {
      return  this.router.url.split('?')[0].split('/')[1] === 'anomalies'
    } else {
      return false
    }
  }

  ngOnInit(): void {
    this.getAnomaliesData();
    this.form = this.getFormsService.getCloseOrder();
    this.formConfig = this.getConfigOrder.getConfigCloseOrder();
    this.order$ = this.store.pipe(select(fromOrders.selectors.getOrder));
  }

  send(): void {
    this.store.dispatch(new CloseOrdersAction({ orderUuids: this.selectedItemsUuid, date: this.form.get('departureDate').value }));
    if (this.isAnomalies) {
      this.closeBSF();
    } else {
      this.close();
    }

  }
  close(): void {
    this.store.dispatch(new OrderClearAction);
    this.store.dispatch(new ClearSelectItemAction);
    this.staticModal.hide();
  }

  // this fonction is used when we call this modal via data table
  closeBSF(): void {
    this.store.dispatch(new OrderClearAction);
    this.store.dispatch(new ClearSelectItemAction);
    this.bsModalRef.hide();
  }
  open(): void {
    this.form.get('departureDate').patchValue(moment());
    this.getSelectedOrderInfo();
    this.staticModal.show();
  }

  ngOnDestroy(): void {
    this.store.dispatch(new  ClearOneItemSubListAction());
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }
  getSelectedOrderInfo(): void {
    this.selectedItemsUuid = [];
    this.sub$ = this.order$.pipe(
      skipWhile(value => _.isEmpty(value))
    ).subscribe((order: Order) => {
      this.selectedItemsUuid = [];
      if (order) {
        this.selectedItemsUuid.push(order.uuid);
      }
    });

    if (this.selectedItemsUuid.length === 0 && this.selectedOrders) {
      for (let i = 0; i < this.selectedOrders.length; i++) {
        this.selectedItemsUuid.push(this.selectedOrders[i].uuid)
      }
    }
    this.subscriptions.push(this.sub$);
  }

  getAnomaliesData(): void {
    this.selectedItemsUuid = [];
    this.selectedItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      if (data) {
        this.selectedItem = data;
        for (let j = 0; j < this.selectedItem.length; j++) {
          this.selectedItemsUuid.push(this.selectedItem[j].orderUuid);
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        this.selectedItemsUuid.push(data.orderUuid);
      }

    });
    this.subscriptions.push(this.sub$);
  }
}
